import React from 'react';
import styles from './DetailsTable.module.css'; //styles


const DetailsTable = ({ user, subscription }) => {
  const safe = (val, fallback = 'N/A') => (val !== undefined && val !== null ? val : fallback);
  const getStatus = () => {
      const status = subscription?.status?.toLowerCase();
      if (!status || status === 'inexistant') return 'Inactive';
      return status.charAt(0).toUpperCase() + status.slice(1);
    };

  return (
    <div className={styles.detailsTableContainer}>
      <div className={styles.rowDark}>
        <div className={styles.fieldName}>Farm Name:</div>
        <div className={styles.fieldValue}>
          {safe(user?.details?.businessName, "John's Dairy Farm")}
        </div>
      </div>

      <div className={styles.rowLight}>
        <div className={styles.fieldName}>Order Status:</div>
        <div className={styles.fieldValue}>
          {getStatus()}
        </div>
      </div>

      <div className={styles.rowDark}>
        <div className={styles.fieldName}>Order Created:</div>
        <div className={styles.fieldValue}>
          {subscription?.created_at
            ? new Date(subscription.created_at).toLocaleDateString()
            : 'N/A'}
        </div>
      </div>

      <div className={styles.rowLight}>
        <div className={styles.fieldName}>Order Type:</div>
        <div className={styles.fieldValue}>
          {safe(subscription?.contract_plan, 'Individual Purchase')
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/\b\w/g, c => c.toUpperCase())}
        </div>
      </div>

      <div className={styles.rowDark}>
        <div className={styles.fieldName}>Quantity Ordered:</div>
        <div className={styles.fieldValue}>
          {subscription?.products?.reduce((sum, p) => sum + (p.amount_to_deliver || 0), 0) || '0'} bags
        </div>
      </div>

      <div className={styles.rowLight}>
        <div className={styles.fieldName}>Payment Status:</div>
        <div className={styles.fieldValue}>
          {safe(subscription?.payment_status, 'Unpaid')}
        </div>
      </div>

      <div className={styles.rowDark}>
        <div className={styles.fieldName}>Deliveries Complete:</div>
        <div className={styles.fieldValue}>
          {safe(subscription?.deliveries_complete, 0)}
        </div>
      </div>
    </div>
  );
};

export default React.memo(DetailsTable);